import React, { useState } from 'react'
import { Modal, Button, List, Icon, Alert } from 'antd'
import ReactPlayer from 'react-player'

const VideoHistoryModal = ({ visible, history, onCancel, onSelect }) => {
  const [previewVideo, setPreviewVideo] = useState(null)

  const handleSelectVideo = video => {
    Modal.confirm({
      title: 'Restore this version?',
      content:
        'This will replace your current shot video with this historical version.',
      okText: 'Yes, Restore',
      cancelText: 'Cancel',
      centered: true,
      icon: <Icon type="exclamation-circle" />,
      onOk() {
        onSelect(video.url)
        setPreviewVideo(null)
      }
    })
  }

  const handleClosePreview = () => {
    setPreviewVideo(null)
  }

  const reversedHistory = history.slice().reverse()

  return (
    <>
      <Modal
        title={
          <span style={{ fontSize: 18, fontWeight: 600 }}>
            Video History{' '}
            <span style={{ color: '#8c8c8c', fontSize: 14, fontWeight: 400 }}>
              ({history.length})
            </span>
          </span>
        }
        visible={visible}
        centered
        onCancel={onCancel}
        footer={null}
        width={600}
        bodyStyle={{
          padding: '24px',
          background: '#f5f7fa',
          maxHeight: '70vh',
          overflowY: 'auto'
        }}
      >
        <Alert
          message="Restore Previous Versions"
          description="Browse through your previously generated videos. Click the eye icon to preview, or 'Restore' to revert to that version."
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <List
          itemLayout="horizontal"
          className="video-history-list"
          dataSource={reversedHistory}
          renderItem={(item, index) => (
            <List.Item
              style={{
                background: '#fff',
                borderRadius: '8px',
                marginBottom: '12px',
                padding: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
              }}
              actions={[
                <Button
                  key="view"
                  type="default"
                  icon="eye"
                  size="small"
                  onClick={() => setPreviewVideo(item)}
                  style={{ marginRight: 8 }}
                >
                  View
                </Button>,
                <Button
                  key="restore"
                  type="primary"
                  ghost
                  icon="rollback"
                  size="small"
                  onClick={() => handleSelectVideo(item)}
                >
                  Restore
                </Button>
              ]}
            >
              <List.Item.Meta
                avatar={
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: '8px',
                      background: '#f4f5fa',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Icon type="video-camera" style={{ fontSize: 20 }} />
                  </div>
                }
                title={
                  <span style={{ fontWeight: 500 }}>
                    Version {history.length - index}
                  </span>
                }
                description={
                  item.timestamp ? (
                    <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                      {new Date(item.timestamp).toLocaleDateString()} at{' '}
                      {new Date(item.timestamp).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  ) : (
                    <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                      No timestamp available
                    </span>
                  )
                }
              />
            </List.Item>
          )}
        />
      </Modal>

      {/* Video Preview Modal */}
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            <Icon type="play-circle" style={{ marginRight: 8 }} />
            Video Preview
          </span>
        }
        visible={!!previewVideo}
        centered
        onCancel={handleClosePreview}
        footer={[
          <Button key="cancel" onClick={handleClosePreview}>
            Close
          </Button>,
          <Button
            key="restore"
            type="primary"
            icon="rollback"
            onClick={() => handleSelectVideo(previewVideo)}
          >
            Restore This Version
          </Button>
        ]}
        width={800}
        bodyStyle={{
          padding: '16px',
          background: '#000'
        }}
        destroyOnClose
      >
        {previewVideo && (
          <div
            style={{
              width: '100%',
              height: 400,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ReactPlayer
              url={previewVideo.url}
              width="100%"
              height="100%"
              controls
              playing
              style={{ objectFit: 'contain' }}
            />
          </div>
        )}
      </Modal>
    </>
  )
}

export default VideoHistoryModal
